import { render, staticRenderFns } from "./PrivateCard.vue?vue&type=template&id=37c5fb02&"
import script from "./PrivateCard.vue?vue&type=script&lang=js&"
export * from "./PrivateCard.vue?vue&type=script&lang=js&"
import style0 from "./PrivateCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports